import React from "react";
import "./App.css";
import SprinterVanBookingForm from "./NashvilleConciergeForm";

function App() {
  return (
    <div className="App">
      <main>
        <SprinterVanBookingForm showProgress={true} />
      </main>
    </div>
  );
}

export default App;
